<ng-container *ngrxLet="{ activeLanguage: activeLanguage$ } as vm">
    <div class="grid header">
        <div class="main-section">
            <h1>
                {{ "dtmMainPageLib.subpage.kpo.results.title" | transloco }}
            </h1>
            <p class="message">
                {{ "dtmMainPageLib.subpage.kpo.results.description" | transloco }}
            </p>
        </div>
    </div>

    <dtm-main-page-lib-kpo-logos [activeLanguage]="vm.activeLanguage" />

    <div class="sections-container">
        <div class="grid info">
            <h2>{{ "dtmMainPageLib.subpage.kpo.results.firstPhaseResultsTitle" | transloco }}</h2>
            <div class="info-container">
                <img ngSrc="/assets/images/kpo/results.svg" alt="" height="84" width="84" />
                <div>
                    <h3>{{ "dtmMainPageLib.subpage.kpo.results.info.title" | transloco }}</h3>
                    <p [innerHTML]="'dtmMainPageLib.subpage.kpo.results.info.description' | transloco"></p>
                </div>
            </div>
        </div>
        <div class="grid results">
            <h2>{{ "dtmMainPageLib.subpage.kpo.results.listHeader" | transloco }}</h2>
            <p class="description">
                {{ "dtmMainPageLib.subpage.kpo.results.listDescription" | transloco }}
            </p>
            <div class="region-table" *ngFor="let region of data?.region">
                <p class="label">{{ "dtmMainPageLib.subpage.kpo.results.voivodeshipLabel" | transloco }}</p>
                <p class="voivodeship">{{ region.name }}</p>
                <div class="data-container">
                    <table mat-table [dataSource]="region.entity">
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef class="col-name">
                                {{ "dtmMainPageLib.subpage.kpo.results.table.nameLabel" | transloco }}
                            </th>
                            <td mat-cell *matCellDef="let element" class="col-name">{{ element.name }}</td>
                        </ng-container>
                        <ng-container matColumnDef="area">
                            <th mat-header-cell *matHeaderCellDef class="col-area">
                                {{ "dtmMainPageLib.subpage.kpo.results.table.areaLabel" | transloco }}
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                                class="col-area"
                                [innerHTML]="'dtmMainPageLib.subpage.kpo.results.table.areaValueLabel' | transloco : { area: element.area }"
                            ></td>
                        </ng-container>

                        <ng-container matColumnDef="leader">
                            <th mat-header-cell *matHeaderCellDef class="col-leader">
                                {{ "dtmMainPageLib.subpage.kpo.results.table.leaderLabel" | transloco }}
                            </th>
                            <td mat-cell *matCellDef="let element" class="col-leader">{{ element.leader }}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                    <div class="map">
                        <img ngSrc="/assets/images/kpo/Variant=PL.svg" alt="" height="260" width="272" />
                        <img
                            class="region"
                            ngSrc="/assets/images/kpo/Variant={{ region.regionCode }}.svg"
                            alt=""
                            height="260"
                            width="272"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="grid results">
            <h2>{{ "dtmMainPageLib.subpage.kpo.results.map.title" | transloco }}</h2>
            <p class="description">
                {{ "dtmMainPageLib.subpage.kpo.results.map.description" | transloco }}
            </p>
            <img
                class="result-map"
                ngSrc="/assets/images/kpo/result-region-map.png"
                alt=""
                height="794"
                width="856"
                ngSrcset="100w, 200w"
            />
        </div>
        <dtm-main-page-lib-info
            [headerText]="'dtmMainPageLib.subpage.kpo.moreInfo.title' | transloco"
            [link]="BROCHURE_FILE"
            [linkText]="'dtmMainPageLib.subpage.kpo.moreInfo.brochureLinkText' | transloco"
            isDownload
        ></dtm-main-page-lib-info>
    </div>
</ng-container>
